import { getLiteral } from 'utils/getLiteral';

export const ONLY_SELECTED_FILTER_ID = 'onlySelected';

/** Normalizes legacy tri-state bool values ('0'/'1'/'2') to a boolean for the switch UI. */
export const normalizeOnlySelectedValue = (value) => {
    if (value === true || value === '1') return true;
    if (value === false || value === '2' || value === '0') return false;
    return !!value;
};

/** Shared schema for the "show only selected" filter (entity list selection). */
export const getOnlySelectedFilterSchema = () => ({
    id: ONLY_SELECTED_FILTER_ID,
    dataType: 'switch',
    description: getLiteral('label_show_selected'),
    isPinnable: false,
    isRemovable: false,
});
